module.exports = __webpack_public_path__ + "static/media/fondo.18655c32.jpg";